import { faCircleExclamation, faFile } from "@fortawesome/free-solid-svg-icons";
import { faCommentAlt } from "@fortawesome/pro-regular-svg-icons/faCommentAlt";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faKey } from "@fortawesome/pro-regular-svg-icons/faKey";
import { faMinusOctagon } from "@fortawesome/pro-regular-svg-icons/faMinusOctagon";
import { faFileCheck } from "@fortawesome/pro-solid-svg-icons/faFileCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@vapor/react-material/Button";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { useTranslation } from "@onefront/react-sdk";
import CardContent from "@vapor/react-material/CardContent";
import Popover from "@vapor/react-material/Popover";
import Stack from "@vapor/react-material/Stack/";
import Tooltip from "@vapor/react-material/Tooltip";
import { enGB, es, it } from "date-fns/locale";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  macroCategoryConstant,
  macroCategoryCostants,
} from "../../common-components/CostantStrings";
import {
  StyledCard,
  StyledCardAction,
  StyledDivParagrapht,
} from "../document-styled-components/CardBoxStyles";
import { StyledCommentCount } from "../document-styled-components/CardListStyles";
import { DateFormater } from "../document-utils/DateFormater";
import { SubtitleAndTitleFormatter } from "../document-utils/subTitleFormater";
import { useDownloadDocument } from "../hooks/api-hooks/useDownloadADocument";

interface cardBox {
  doc: any;
  workspaceId: string;
}

const CardBox = ({ doc, workspaceId }: cardBox) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [documentType, setDocumentType] = useState<string>();
  const open = Boolean(anchorEl);

  const { t, i18n } = useTranslation("DOCS");
  const locale =
    i18n.language === "it" ? it : i18n.language === "en" ? enGB : es;

  const checkIfEncrypted = doc.encrypted;
  const checkVisibility = doc.visibleByAccountantOnl;

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isEmbeded = query.get("embed");

  const isFatture = useMemo(() => doc?.einvoice === true, [doc]);

  const { data: download, fetch } = useDownloadDocument(
    doc.documentId,
    workspaceId,
    doc.fileName,
    documentType,
    isFatture
  );

  const documentSearchPercentageScore =
    doc?.documentSearchScorePercentage === "NaN"
      ? 0
      : doc?.documentSearchScorePercentage;

  const documentSearchPercentage =
    documentSearchPercentageScore !== 0
      ? "Corrispondenza  " + doc?.documentSearchScorePercentage + "%"
      : "";

  const navigate = useNavigate();
  const infoList = doc?.infoList || [];
  const filteredInfoList = infoList
    .filter((x: any) => x.name !== "Filename" && x.name !== "DATE")
    .filter((x: any) => x.value !== "");
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: { currentTarget: any }) => {
    isFatture ? setAnchorEl(event.currentTarget) : setDocumentType("ASSOSW");
  };

  useEffect(() => {
    if (documentType === "ASSOSW" || documentType === " ") {
      fetch();
    }
  }, [documentType]);

  const macro = doc?.standardTags.filter(
    (val: { name: string }) => val.name === "macrocategory"
  )[0].value;

  const icon =
    macroCategoryConstant.get(macro) || macroCategoryCostants.tutti.icon;

  return (
    <>
      <StyledCard key={doc.documentId}>
        <Link
          to={`/document-details/${doc.documentId}/${workspaceId}${
            isEmbeded ? "?embed=true" : ""
          }`}
          style={{ textDecoration: "none", color: "black " }}
        >
          <CardContent style={{ height: "82%" }}>
            <div>
              <Stack direction="row" justifyContent="space-between">
                <Typography
                  variant="caption"
                  marginBottom={1}
                  color={documentSearchPercentageScore > 80 ? "green" : "grey"}
                >
                  {documentSearchPercentage}
                </Typography>
                <Stack direction="row" gap={1}>
                  {doc.urgent && (
                    <FontAwesomeIcon
                      icon={faCircleExclamation}
                      style={{ marginLeft: "10px" }}
                      color="#D92B2C"
                      size="sm"
                    ></FontAwesomeIcon>
                  )}
                  <FontAwesomeIcon
                    style={{ float: "right" }}
                    icon={doc.read ? faFileCheck : faFile}
                    color={
                      doc.userType === "ACCOUNTANT" ? "#152935" : "#0177ac"
                    }
                    size="sm"
                  ></FontAwesomeIcon>
                </Stack>
              </Stack>
              <Stack
                style={{ display: "inline" }}
                direction={"row"}
                justifyContent="space-between"
              >
                <FontAwesomeIcon
                  style={{
                    float: "left",
                    marginRight: "15px",
                    color: "#005075",
                    marginTop: "10px",
                  }}
                  size="lg"
                  icon={icon}
                />
                <Stack direction="row" justifyContent="space-between">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      fontFamily={"Cairo"}
                      fontWeight={600}
                      color="#005075"
                      fontSize={"20px"}
                      style={{
                        maxWidth: "300px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        wordWrap: "break-word",
                      }}
                    >
                      {SubtitleAndTitleFormatter(doc?.category)}
                    </Typography>
                  </div>
                  <Stack
                    direction="row"
                    alignItems="top"
                    paddingTop={1}
                    gap={1}
                  >
                    {checkVisibility && (
                      <FontAwesomeIcon
                        size="sm"
                        color="red"
                        icon={faKey}
                      ></FontAwesomeIcon>
                    )}
                    {checkIfEncrypted && (
                      <FontAwesomeIcon
                        size="sm"
                        color="red"
                        icon={faMinusOctagon}
                      />
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </div>
            <Typography
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "13%",
                maxWidth: "300px",
                padding: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordWrap: "break-word",
              }}
              fontFamily={"Cairo"}
              color="#005075"
              fontSize={"14px"}
            >
              {SubtitleAndTitleFormatter(doc?.subTitle)}
              {/* {useFormatDocumentName(doc.fileName)} */}
            </Typography>

            <StyledDivParagrapht>
              {filteredInfoList.map((info: any) => (
                <Stack direction="row">
                  <Typography
                    style={{ marginRight: "5px" }}
                    fontFamily={"Roboto"}
                    fontSize={"13px"}
                  >
                    {t("document." + info.name)}:
                  </Typography>
                  <Typography fontSize={"14px"} fontWeight={"bold"}>
                    {info.name === "Creation date" ||
                    info.name === "Document date"
                      ? DateFormater(info.value, locale)
                      : info.value}
                  </Typography>
                </Stack>
              ))}
            </StyledDivParagrapht>
          </CardContent>
        </Link>
        <StyledCardAction>
          <Tooltip title={t("document.openComments")} placement="top" arrow>
            <Button
              onClick={() =>
                navigate(
                  `document-details/${doc.documentId}/${workspaceId}${
                    isEmbeded ? "?embed=true" : ""
                  }`
                )
              }
              style={{
                padding: 0,
                minHeight: 0,
                minWidth: 0,
                marginRight: "15px",
              }}
            >
              <StyledCommentCount>
                {doc.notesCount > 100 ? "99+" : doc.notesCount}
              </StyledCommentCount>
              <FontAwesomeIcon color="#0090d1" size="lg" icon={faCommentAlt} />
            </Button>
          </Tooltip>
          <Tooltip placement="top" title={t("document.preview")} arrow>
            <Button
              size="medium"
              style={{
                padding: 0,
                minHeight: 0,
                minWidth: 0,
                marginRight: "20px",
              }}
            >
              <FontAwesomeIcon
                color="#0090d1"
                size="lg"
                icon={faEye}
                onClick={() =>
                  navigate(
                    `document-details/${doc.documentId}/${workspaceId}${
                      isEmbeded ? "?embed=true" : ""
                    }`
                  )
                }
              />
            </Button>
          </Tooltip>
          <Tooltip arrow placement="top" title={t("document.download")}>
            <Button
              size="medium"
              style={{
                padding: 0,
                minHeight: 0,
                minWidth: 0,
                marginRight: "20px",
              }}
            >
              <FontAwesomeIcon
                size="lg"
                key={doc.documentId}
                onClick={handleClick}
                icon={faDownload}
              />
            </Button>
          </Tooltip>
          {isFatture && (
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Typography
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                margin={2}
                onClick={() => {
                  setDocumentType("ASSOSW");
                }}
              >
                {t("document.downloadPdf")}
              </Typography>
              <Typography
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                margin={2}
                onClick={() => {
                  setDocumentType(" ");
                }}
              >
                {t("document.downloadXml")}
              </Typography>
            </Popover>
          )}
        </StyledCardAction>
      </StyledCard>
    </>
  );
};

export default CardBox;
